// https://felixgerschau.com/create-a-pwa-update-notification-with-create-react-app/
import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { notify } from "@/modules/notify/notify";

import { UpdateAppDialog } from "./components/UpdateAppDialog";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

const translationNamespace = "common/ServiceWorkerInitializer";
const isAppUpdatedKey = "isAppUpdated";

export const ServiceWorkerInitializer: React.FC = () => {
  const [isUpdateDialogOpen, setIsUpdateDialogOpen] = useState(false);
  const [waitingWorker, setWaitingWorker] = useState<ServiceWorker | null>(
    null
  );
  const [isUpdating, setIsUpdating] = useState(false);

  const { t } = useTranslation(translationNamespace);

  const onServiceWorkerUpdate = useCallback(
    (registration: ServiceWorkerRegistration) => {
      setIsUpdateDialogOpen(true);
      setWaitingWorker(registration.waiting);
    },
    []
  );

  const reloadPage = useCallback(() => {
    setIsUpdating(true);
    waitingWorker?.postMessage({ type: "SKIP_WAITING" });

    const timestamp = new Date().getTime().toString();
    localStorage.setItem(isAppUpdatedKey, timestamp);

    window.location.reload();
  }, [waitingWorker]);

  useEffect(() => {
    serviceWorkerRegistration.register({ onUpdate: onServiceWorkerUpdate });
  }, [onServiceWorkerUpdate]);

  useEffect(() => {
    const isAppUpdated = localStorage.getItem(isAppUpdatedKey);
    if (isAppUpdated) {
      notify.alert.success(t("The app has been successfully updated!"));
    }
    localStorage.removeItem(isAppUpdatedKey);
  }, [t]);

  return (
    <UpdateAppDialog
      isUpdateDialogOpen={isUpdateDialogOpen}
      isUpdating={isUpdating}
      onClose={reloadPage}
    />
  );
};
